import React from "react";
import styles from "../../../GiveawayDetails/GiveawayDetails.module.css";
import { GiveawayActive, GiveawayArchieve } from "../../../../types";
import { TimeDisplay } from "../../../../../../../utils/TimeDisplay";
import calendar from "/calendarIcon.svg";
import telegramNFT from "/nftTelegram.png";
import telegramNFT_black from "/nftTelegram_black.png";
import character_prize from "/giveawayDetailsPrizes/character-prizeNew.png";
import character_prize_black from "/giveawayDetailsPrizes/character-prize_black.png";
import less_dc from "/giveawayDetailsPrizes/less_dc.png";
import less_dc_black from "/giveawayDetailsPrizes/less_dc_black.png";
import many_dc from "/giveawayDetailsPrizes/many_dc.png";
import many_dc_black from "/giveawayDetailsPrizes/many_dc_black.png";
import wheel from "/giveawayDetailsPrizes/prize-tickets-to-spin.png";
import wheel_black from "/giveawayDetailsPrizes/prize-tickets-to-spin_black.png";
import usersLogo from "/usersLogo.svg";
import winnerBanner from "/prize-banner.svg";
import winnerBanner_black from "/public/prize-bannerBlack.svg";
import { getTicketWord } from "../../../../../../Services/utils";
import CharacterLogo from "/character-circle-gold.svg";
import dreamcoinLogo from "/DC_coin.svg";
import telegramNFTLogo from "/telegramNFT.svg";

interface FinishedGiveawayInfoProps {
  giveaway: GiveawayActive | GiveawayArchieve;
  handleClaim: (place: number) => void;
  isVisible: boolean;
  currentSlide: number;
  setCurrentSlide: (index: number) => void;
  userID: number;
  tg: any;
}
const FinishedGiveawayInfo: React.FC<FinishedGiveawayInfoProps> = ({
  giveaway,
  handleClaim,
  isVisible,
  currentSlide,
  setCurrentSlide,
  userID,
}) => {
  const getPrizeImage = (
    giveaway: GiveawayArchieve | null,
    prizeIndex: number = 0
  ): string => {
    if (
      !giveaway ||
      !giveaway.user_metadata ||
      !giveaway.user_metadata.prize[prizeIndex]
    ) {
      return "";
    }

    const prize = giveaway.user_metadata.prize[prizeIndex];

    if (prize.is_claimed === false) {
      switch (prize.type) {
        case "TelegramNFT":
          return telegramNFT;
        case "Character":
          return character_prize;
        case "DC":
          return prize.amount <= 5000 ? less_dc : many_dc;
        case "TICKET":
          return wheel;
        default:
          return character_prize;
      }
    } else {
      switch (prize.type) {
        case "TelegramNFT":
          return telegramNFT_black;
        case "Character":
          return character_prize_black;
        case "DC":
          return prize.amount <= 5000 ? less_dc_black : many_dc_black;
        case "TICKET":
          return wheel_black;
        default:
          return character_prize_black;
      }
    }
  };
  const formatNumber = (num: number): string => {
    return num.toLocaleString("en-US");
  };
  return (
    <div className={styles.infoContainer}>
      <div className={styles.rulesContainer}>
        <div className={styles.leftPart}>
          <div className={styles.finishedDate}>
            <div className={styles.finishedDateDate}>
              <TimeDisplay endDate={giveaway.end_date} format="short" />
            </div>
            <img src={calendar} alt="" />
          </div>
          <div className={styles.costDescription}>Дата проведения</div>
        </div>
        <div className={styles.rightPart}>
          <div className={styles.participants}>
            <div className={styles.participantsWrapper}>
              <div>{giveaway.total_participants}</div>
              <img src={usersLogo} alt="" />
            </div>
          </div>
          <div className={styles.participantsDescription}>
            Количество участников
          </div>
        </div>
      </div>

      {giveaway.status === "finish" &&
        (giveaway as GiveawayArchieve).user_metadata.is_participant && (
          <>
            <div
              className={styles.winnerBannerContainer}
              onScroll={(e) => {
                const container = e.currentTarget;
                const scrollLeft = container.scrollLeft;
                const itemWidth = container.offsetWidth;
                const newIndex = Math.round(scrollLeft / itemWidth);
                setCurrentSlide(newIndex);
              }}
            >
              {(giveaway as GiveawayArchieve).user_metadata.prize.map(
                (prize, index) => (
                  <div
                    className={styles.winnerBanner}
                    key={index}
                    style={{ scrollSnapAlign: "start" }}
                  >
                    <img
                      className={
                        prize.is_claimed === false
                          ? styles.winnerBannerImg
                          : styles.winnerBannerImg_hidden
                      }
                      src={winnerBanner}
                      alt=""
                    />
                    <img
                      className={
                        prize.is_claimed === true
                          ? styles.winnerBannerImg_black
                          : styles.winnerBannerImg_black_hidden
                      }
                      src={winnerBanner_black}
                      alt=""
                    />

                    <div className={styles.winnerBannerLeftPart}>
                      <div className={styles.winnerBannerPrize}>
                        <div className={styles.winnerBannerText}>
                          Твой выигрыш:
                        </div>
                        <div className={styles.winnerBannerAmount}>
                          {prize.type === "Character" ? (
                            <>Легендарный</>
                          ) : prize.type === "DC" ? (
                            <>{formatNumber(prize.amount)}</>
                          ) : prize.type === "TelegramNFT" ? (
                            <>Подарок</>
                          ) : (
                            <>
                              {formatNumber(prize.amount)}{" "}
                              {getTicketWord(prize.amount)}
                            </>
                          )}
                          {prize.type === "TICKET" ? (
                            <></>
                          ) : (
                            <>
                              <img
                                src={
                                  prize.type === "DC"
                                    ? dreamcoinLogo
                                    : prize.type === "TelegramNFT"
                                    ? telegramNFTLogo
                                    : CharacterLogo
                                }
                                alt="token"
                                className={styles.tokenIcon}
                              />
                            </>
                          )}
                        </div>
                        <button
                          onClick={() => handleClaim(prize.place)}
                          disabled={prize.is_claimed === false ? false : true}
                          className={
                            prize.is_claimed === false
                              ? styles.claimButton
                              : styles.claimedButton
                          }
                        >
                          {prize.is_claimed === false
                            ? "Получить"
                            : "Награда получена"}
                        </button>
                      </div>
                    </div>

                    <div
                      className={
                        prize.type === "TICKET" ||
                        prize.type === "DC" ||
                        prize.type === "TelegramNFT"
                          ? styles.wheelContainer
                          : styles.winnerBannerRightPart
                      }
                    >
                      <img
                        src={getPrizeImage(giveaway as GiveawayArchieve, index)}
                        alt="coins"
                        className={`${styles.coinsImage} ${
                          prize.type === "TelegramNFT" ? styles.telegramNFT : ""
                        } ${isVisible ? styles.visible : styles.hidden}`}
                      />
                    </div>
                  </div>
                )
              )}
            </div>
            {(giveaway as GiveawayArchieve).user_metadata.prize.length > 1 && (
              <div className={styles.sliderDotsContainer}>
                {(giveaway as GiveawayArchieve).user_metadata.prize.map(
                  (_, index) => (
                    <div
                      key={index}
                      className={`${styles.dot} ${
                        currentSlide === index ? styles.activeDot : ""
                      }`}
                      onClick={() => {
                        const container = document.querySelector(
                          `.${styles.winnerBannerContainer}`
                        ) as HTMLElement;
                        if (container) {
                          container.scrollTo({
                            left: index * container.offsetWidth,
                            behavior: "smooth",
                          });
                        }
                      }}
                    />
                  )
                )}
              </div>
            )}
          </>
        )}
    </div>
  );
};

export default FinishedGiveawayInfo;
